import { environment } from '@environment/environments';

export const buildWebSocketUrl = (accessToken: string): string =>
  `${environment.wsUrl}?token=${encodeURIComponent(accessToken)}`;
